<template>
    <div class="section text-center mt-1" v-if="loading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>
    <div class="section pt-1" v-if="!loading">
        <div class="wallet-card">
            <div class="balance">
                <div class="left">
                    <h1 class="total text-primary text-center" v-html="event_details.name"></h1>
                    <span class="title text-center" v-html="event_details.place"></span>
                    <span class="title text-center" v-html="event_details.date"></span>
                </div>
            </div>
        </div>
    </div>
    <div class="section mt-1" v-if="!loading && volunteer_message">
        <div class="card">
            <div class="card-body">
                {{ volunteer_message }}
            </div>
        </div>
    </div>
    <div class="section mt-1" v-if="!loading">
        <Form @submit="updateVolunteer" :validation-schema="schema">
            <div class="wallet-card mt-1">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group basic" v-if="member_list.length > 1">
                            <div class="input-wrapper">
                                <label class="label" for="stay"><span>Member</span></label>
                                <Field as="select" class="form-control custom-select" v-model="member_id" name="member_id"
                                    id="select4" @change="changeMember">
                                    <option value>--Select--</option>
                                    <option v-for="member in member_list" v-bind:key="member.id" v-bind:value="member.id">
                                        {{ member.name }}
                                    </option>
                                </Field>
                                <ErrorMessage name="member_id" class="error-feedback" />
                            </div>
                        </div>

                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label" for="stay"><span>വളണ്ടിയർ ആകാൻ തയ്യാറാണോ?</span></label>
                                <Field as="select" class="form-control custom-select" v-model="volunteer_ready"
                                    name="volunteer_ready" id="select4" @change="readyChange">
                                    <option value="Y">അതെ</option>
                                    <option value="N">അല്ല</option>
                                </Field>
                                <ErrorMessage name="volunteer_ready" class="error-feedback" />
                            </div>
                        </div>

                        <div class="form-group basic" v-if="volunteer_ready == 'Y'">
                            <div class="input-wrapper">
                                <label class="label" for="stay"><span>വളണ്ടിയർ ആകാൻ താല്പര്യമുള്ള വകുപ്പ്
                                        തിരഞ്ഞെടുക്കുക.</span></label>
                                <Field as="select" class="form-control custom-select" v-model="volunteer_department"
                                    name="volunteer_department" id="select4" @change="changeDep">
                                    <option value>--Select--</option>
                                    <option v-for="department in department_list" v-bind:key="department"
                                        v-bind:value="department.id">
                                        {{ department.name }}
                                    </option>
                                </Field>
                                <span id="volunteer_department" class="error-feedback">{{
                                    volunteer_department_message
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group basic" v-if="volunteer_ready == 'Y'">
                            <div class="input-wrapper">
                                <label class="label" for="stay"><span>നിങ്ങൾക്കു എത്തിച്ചേരാൻ കഴിയുന്ന ദിവസം?</span></label>
                                <div class="input-group d-flex align-items-center mt-1">
                                    <div class="form-check form-check-inline" v-for="item in time_list" :key="item">
                                        <Field class="form-check-input" name="volunteer_time" type="checkbox"
                                            :id="'volunteer_time_' + item" :value="item" v-model="volunteer_time" />
                                        <label class="form-check-label" :for="'volunteer_time_' + item">{{ item }}</label>
                                    </div>
                                </div>
                                <span id="volunteer_time" class="error-feedback">{{ volunteer_time_message }}</span>
                            </div>
                        </div>

                        <div class="form-group basic" v-if="volunteer_ready == 'Y'">
                            <div class="input-wrapper">
                                <label class="label" for="stay"><span>താങ്കൾക്കുള്ള ശാരീരിക പ്രയാസങ്ങൾ?</span></label>
                                <div class="input-group d-flex align-items-center mt-1">
                                    <div class="form-check form-check-inline" v-for="item in health_status_list" :key="item">
                                        <Field class="form-check-input" name="health_status" type="checkbox"
                                            :id="'health_status_' + item" :value="item" v-model="health_status" />
                                        <label class="form-check-label" :for="'health_status_' + item">{{ item }}</label>
                                    </div>
                                </div>
                                <span id="health_status" class="error-feedback">{{ health_status_message }}</span>
                            </div>
                        </div>

                        <!-- <div class="form-group basic" v-if="permissions.t_shirt_enable">
                            <div class="input-wrapper">
                                <label class="label" for="stay"><span>T Shirt Size</span></label>
                                <div class="input-group d-flex align-items-center mt-1">
                                    <div class="form-check form-check-inline" v-for="tshirt in tshirt_list" :key="tshirt">
                                        <Field class="form-check-input" name="volunteer_tshirt_size" type="radio"
                                            :id="'tshirt_size_' + tshirt" :value="tshirt" v-model="volunteer_tshirt_size" />
                                        <label class="form-check-label" :for="'tshirt_size_' + tshirt">{{ tshirt }}</label>
                                    </div>
                                </div>
                                <span id="volunteer_tshirt_size" class="error-feedback">{{ volunteer_time_message }}</span>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <button type="submit" class="btn btn-primary btn-block btn-md mt-1" :disabled="btn_loading"
                v-if="permissions.update_volunteer">
                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                <span>Save</span>
            </button>
            <button type="button" class="btn btn-primary btn-block btn-md mt-1" v-if="!permissions.update_volunteer">
                Close
            </button>
        </Form>
    </div>
    
    <div class="section mt-1" v-if="!loading && showAddForm">
        <div class="wallet-card">
            <h3 class="text-center mb-3">Add New Volunteer</h3>
            <Form @submit="updateVolunteer" :validation-schema="schema">
                <div class="wallet-card mt-1">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="text4b">Member</label>
                                    <v-select label="text" :filterable="true"
                                        v-model="new_member" :value="new_member" :options="member_list"
                                        @input="getTextList($event.target.value, 0)">
                                        <template>
                                            type to search...
                                        </template>
                                        <template>
                                            <div class="d-center">
                                                {{ new_member.name }}
                                            </div>
                                        </template>
                                    </v-select>
                                    <ErrorMessage name="member" class="error-feedback" />
                                </div>
                            </div>
                            <div class="input-info" v-if="new_member">Mobile :{{ new_member.country_code }} {{ new_member.mobile }}</div>

                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="stay"><span>വളണ്ടിയർ ആകാൻ താല്പര്യമുള്ള വകുപ്പ്
                                            തിരഞ്ഞെടുക്കുക.</span></label>
                                    <Field as="select" class="form-control custom-select" v-model="new_volunteer_department"
                                        name="volunteer_department" id="select4" @change="changeDep">
                                        <option value>--Select--</option>
                                        <option v-for="department in department_list" v-bind:key="department"
                                            v-bind:value="department.id">
                                            {{ department.name }}
                                        </option>
                                    </Field>
                                    <span id="volunteer_department" class="error-feedback">{{
                                        volunteer_department_message
                                    }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="stay"><span>നിങ്ങൾക്കു എത്തിച്ചേരാൻ കഴിയുന്ന ദിവസം?</span></label>
                                    <div class="input-group d-flex align-items-center mt-1">
                                        <div class="form-check form-check-inline" v-for="item in time_list" :key="item">
                                            <Field class="form-check-input" name="volunteer_time" type="checkbox"
                                                :id="'new_time_' + item" :value="item" v-model="new_volunteer_time" />
                                            <label class="form-check-label" :for="'new_time_' + item">{{ item }}</label>
                                        </div>
                                    </div>
                                    <span id="volunteer_time" class="error-feedback">{{
                                        volunteer_time_message
                                    }}</span>
                                </div>
                            </div>

                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label" for="stay"><span>താങ്കൾക്കുള്ള ശാരീരിക പ്രയാസങ്ങൾ?</span></label>
                                    <div class="input-group d-flex align-items-center mt-1">
                                        <div class="form-check form-check-inline" v-for="item in health_status_list" :key="item">
                                            <Field class="form-check-input" name="health_status" type="checkbox"
                                                :id="'new_health_' + item" :value="item" v-model="new_health_status" />
                                            <label class="form-check-label" :for="'new_health_' + item">{{ item }}</label>
                                        </div>
                                    </div>
                                    <span id="health_status" class="error-feedback">{{
                                        health_status_message
                                    }}</span>
                                </div>
                            </div>

                            <!-- <div class="form-group basic" v-if="permissions.t_shirt_enable">
                                <div class="input-wrapper">
                                    <label class="label" for="stay"><span>T Shirt Size</span></label>
                                    <div class="input-group d-flex align-items-center mt-1">
                                        <div class="form-check form-check-inline" v-for="tshirt in tshirt_list" :key="tshirt">
                                            <Field class="form-check-input" name="volunteer_tshirt_size" type="radio"
                                                :id="'new_tshirt_' + tshirt" :value="tshirt" v-model="new_volunteer_tshirt_size" />
                                            <label class="form-check-label" :for="'new_tshirt_' + tshirt">{{ tshirt }}</label>
                                        </div>
                                    </div>
                                    <span id="volunteer_tshirt_size" class="error-feedback">{{
                                        volunteer_time_message
                                    }}</span>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-between mt-3">
                    <button type="button" class="btn btn-secondary btn-md" @click="showAddForm = false">Cancel</button>
                    <button type="submit" class="btn btn-primary btn-md" :disabled="btn_loading">
                        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                        <span>Save</span>
                    </button>
                </div>
            </Form>
        </div>
    </div>
    <div class="section mt-1" v-if="!loading && currentUser.user_level <= 3">
        <div class="wallet-card">
            <h4 class="mb-3">Volunteer List</h4>
            <div class="table-responsive" style="max-height: 250px;">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 60px;">SL</th>
                            <th scope="col">Name</th>
                            <th scope="col">Mobile</th>
                            <th scope="col">Unit</th>
                        </tr>
                    </thead>
                    <tbody style="max-height: 200px; overflow-y: auto;">
                        <tr v-for="(volunteer, index) in volunteer_list" :key="volunteer.id">
                            <td>{{ index + 1 }}</td>
                            <td>{{ volunteer.member ? volunteer.member.name : volunteer.name }}</td>
                            <td>{{ volunteer.member ? volunteer.member.mobile : volunteer.mobile }}</td>
                            <td>{{ volunteer.member && volunteer.member.unit_name ? volunteer.member.unit_name : (volunteer.unit_name || '') }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="section mt-1" v-if="!loading && currentUser.user_level <= 3">
        <button type="button" class="btn btn-primary btn-block btn-md" @click="showAddForm = true" v-if="!showAddForm">
            Add Volunteer
        </button>
    </div>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import {
    Form,
    Field,
    ErrorMessage
} from "vee-validate";
import $ from "jquery";
import * as yup from "yup";
import UserService from "../../../services/user.service";
import AlertModel from "./../../layouts/AlertModel.vue";
import DialogModel from "./../../layouts/DialogModel.vue";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
    name: "Admin List",
    props: {
        unit_id: null,
    },
    components: {
        Form,
        Field,
        ErrorMessage,
        AlertModel,
        DialogModel,
        vSelect
    },
    data() {
        const schema = yup.object().shape({
            volunteer_department: yup.string().required("ഫിൽ ചെയ്യുക"),
        });
        return {
            showAddForm: false,
            new_member: null,
            new_member_id: "",
            new_volunteer_department: "",
            new_volunteer_time: [],
            new_health_status: [],
            new_volunteer_tshirt_size: "",
            alert_type: "",
            alert_message: "",
            dialog_message: "",
            dialog_action: "",
            dialog_action_params: [],

            loading: false,
            btn_loading: false,
            schema,
            event_details: {},
            permissions: [],
            volunteer_message: "",
            volunteer_department: "",
            volunteer_ready: "",
            volunteer_tshirt_size : "",
            department_list: [],
            member_list: [],
            member_id: "",
            volunteer_department_message: "",
            volunteer_time_message: "",
            time_list: [],
            tshirt_list: [],
            volunteer_time: [],
            health_status: [],
            health_status_list: [],
            health_status_message: "",
            volunteer_list: [],
            member_unit: "",
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
        }
        this.user_level = parseInt(this.$route.params.sub_level) || 3;
        this.$root.updateParent("Volunteer Registration");
        this.getEventDetails();
        window.onpopstate = function () {
            if ($("body").hasClass("modal-open")) {
                location.reload();
            }
        };
    },

    methods: {
        getTextList(event, type) {
            this.message = '';
            let data = {
                q: event,
                type: type,
                filter: 'inside',
                unit_id: this.$route.params.id,
                user_level: this.currentUser.user_level
            }
            UserService.authPostRequest('get-typehead-values', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.member_list = response.data.data.list;
                        if (event && event.id) {
                            this.new_member_id = event.id;
                            this.new_member = {
                                ...event,
                                unit: event.unit // Store unit from member selection
                            };
                        }
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        changeMember(member) {
            if (member == 4 || member == 6) {
                this.getComboboxValues(this.event_details.event_capital + "_VDL");
            } else {
                this.getComboboxValues(this.event_details.event_capital + "_VDG");
            }
        },
        getEventDetails() {
            this.loading = true;
            let data = {
                slug: this.$route.params.slug,
                event_id: this.$route.params.event_id,
                page: "volunteer",
            };
            UserService.authPostRequest(`get-event-details`, data).then(
                (response) => {
                    if (response.data.status == "success") {
                        this.event_details = response.data.data.event_details;
                        this.volunteer_list = response.data.data.volunteer_list || [];
                        this.time_list = response.data.data.volunteer_times;
                        this.tshirt_list = response.data.data.volunteer_t_shirt;
                        this.health_status_list = response.data.data.volunteer_health_status;
                        this.permissions = response.data.data.permissions;
                        this.volunteer_message = response.data.data.message;
                        this.member_list = response.data.data.members;
                        this.department_list = response.data.data.departments || [];
                        
                        if (response.data.data.volunteer) {
                            this.member_id = response.data.data.volunteer.member_id;
                            this.volunteer_ready = "Y";
                            this.volunteer_department = response.data.data.volunteer.department_id;
                            this.volunteer_time = JSON.parse(response.data.data.volunteer.time);
                            this.health_status = JSON.parse(response.data.data.volunteer.health_status);
                            this.volunteer_tshirt_size = response.data.data.volunteer.volunteer_tshirt_size;
                        }
                        if (this.member_list.length == 1) {
                            this.member_id = this.member_list[0].id;
                            let wing = this.member_list[0].wing;
                            if (wing == 4 || wing == 6) {
                                this.getComboboxValues(this.event_details.event_capital + "_VDL");
                            } else {
                                this.getComboboxValues(this.event_details.event_capital + "_VDG");
                            }
                        } else {
                            this.member_list.forEach((element) => {
                                if (element.mobileSelf == "Y") {
                                    this.member_id = element.id;
                                    let wing = element.wing;
                                    if (wing == 4 || wing == 6) {
                                        this.getComboboxValues(this.event_details.event_capital + "_VDL");
                                    } else {
                                        this.getComboboxValues(this.event_details.event_capital + "_VDG");
                                    }
                                }
                            });
                        }
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getComboboxValues(code, id = null) {
            var data = {
                code: code,
                type_id: id,
                member_id: this.member_id,
            };
            UserService.getCombobox(data).then(
                (response) => {
                    switch (code) {
                        case this.event_details.event_capital + "_VDL":
                            this.department_list = response.data.data.list.options;
                            break;
                        case this.event_details.event_capital + "_VDG":
                            this.department_list = response.data.data.list.options;
                            break;
                        default:
                            break;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        changeDep() {
            this.volunteer_department_message = "";
        },
        updateVolunteer() {
            if (this.showAddForm) {
                // Handle Add Volunteer form submission
                if (!this.new_member) {
                    this.alert_type = 'Warning';
                    this.alert_message = 'Please select a member';
                    this.$refs.alert_model.openModel();
                    return;
                }
                
                this.loading = true;
                let formData = {
                    member_id: this.new_member.id,
                    event_id: this.$route.params.event_id,
                    volunteer_ready: "Y",
                    volunteer_department: this.new_volunteer_department,
                    volunteer_time: this.new_volunteer_time,
                    health_status: this.new_health_status,
                    volunteer_tshirt_size: this.new_volunteer_tshirt_size,
                    add_registration: true
                };

                UserService.authPostRequest('store-event-volunteer', formData).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.status == 'success') {
                            this.alert_type = 'Success';
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                            
                            this.new_member = null;
                            this.new_volunteer_department = '';
                            this.new_volunteer_time = [];
                            this.new_health_status = [];
                            this.new_volunteer_tshirt_size = '';
                            this.getEventDetails();
                            this.showAddForm = false;
                        } else if (response.data.status == 'warning') {
                            this.alert_type = 'Warning';
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                        } else {
                            this.alert_type = 'Error';
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.alert_type = 'Error';
                        this.alert_message = (error.response && 
                            error.response.data && 
                            error.response.data.message) || 
                            'Failed to save volunteer';
                        this.$refs.alert_model.openModel();
                    }
                );
            } else {
                // Handle main form submission
                this.loading = true;
                let formData = {
                    member_id: this.member_id,
                    event_id: this.$route.params.event_id,
                    volunteer_ready: "Y",
                    volunteer_department: this.volunteer_department,
                    volunteer_time: this.volunteer_time,
                    health_status: this.health_status,
                    volunteer_tshirt_size: this.volunteer_tshirt_size
                };

                UserService.authPostRequest('store-event-volunteer', formData).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.status == 'success') {
                            this.alert_type = 'Success';
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                            this.getEventDetails();
                        } else if (response.data.status == 'warning') {
                            this.alert_type = 'Warning';
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                        } else {
                            this.alert_type = 'Error';
                            this.alert_message = response.data.message;
                            this.$refs.alert_model.openModel();
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.alert_type = 'Error';
                        this.alert_message = (error.response && 
                            error.response.data && 
                            error.response.data.message) || 
                            'Failed to save volunteer';
                        this.$refs.alert_model.openModel();
                    }
                );
            }
        },
        getDepartmentName(department_id) {
            const department = this.department_list.find(dept => dept.id === department_id);
            return department ? department.name : '';
        },
    },
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.form-check {
    margin-right: 15px;
}

.form-check-label {
    cursor: pointer;
    padding: 5px 10px;
    border-radius: 4px;
    transition: all 0.2s ease;
    user-select: none;
}

.form-check-input {
    cursor: pointer;
}

.form-check-inline {
    display: inline-flex;
    align-items: center;
    padding: 0;
    margin-right: 1rem;
}

.table-responsive {
    overflow-y: auto;
    border: 1px solid #eee;
    border-radius: 8px;
}

.table {
    margin-bottom: 0;
}

.table thead th {
    background: #fff;
    border-bottom: 2px solid #dee2e6;
    position: sticky;
    top: 0;
    z-index: 1;
}

.table tbody {
    border-top: none;
}

.table td, .table th {
    padding: 10px;
    vertical-align: middle;
}

.wallet-card {
    background: #ffffff;
    border-radius: 10px;
}

.wallet-card .balance {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0px;
    height: auto;
}

.wallet-card .wallet-footer .item .icon-wrapper {
    width: 100%;
    height: 48px;
    display: inline-flex;
    align-items: left;
    justify-content: left;
    border-radius: 10px;
    color: #fff;
    margin-bottom: 14px;
    padding-left: 10px;
}

.menu-title {
    color: #fff !important;
    font-size: 12px !important;
    padding-left: 5px !important;
    text-align: left !important;
}

.wallet-card .balance .total {
    font-weight: 700;
    letter-spacing: -0.01em;
    line-height: 1em;
    font-size: 24px;
}

.wallet-card .balance .title {
    color: #27173e;
    font-weight: 500;
    font-size: 14px;
    display: block;
    margin-bottom: 0px;
}
</style>
